import React, { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import AuthService from "./services/AuthService";
import ContextWrapper from "./Context/ContextWrapper";
import Routes from "./routes";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./index.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import Header from "./components/Header/Header";

const App = () => {
  // Get auth state from Redux store
  const { isAuthenticated, user } = useSelector(state => state.userAuth);
  
  // Initialize auth service when app loads
  useEffect(() => {
    // Initialize auth promise
    AuthService.initAuthPromise();
    
    // If user is already authenticated (from persisted state)
    // immediately set auth as ready
    if (isAuthenticated && user?.id) {
      console.log('App: User already authenticated, setting auth ready');
      AuthService.setAuthReady({
        userId: user.id,
        token: user.token
      });
    } else {
      console.log('App: Auth not ready, waiting for login');
    }
  }, [isAuthenticated, user?.id, user?.token]);
  return (
    <Fragment>
      {/* <Header></Header> */}
      <Routes />
      <ToastContainer
        position="bottom-right"
        autoClose={2500}
        hideProgressBar
        closeOnClick
        draggable
        pauseOnHover
        closeButton={false}
      />
    </Fragment>
  );
};

export default App;
